import {styled} from '@mui/material';
import backgroundLoginSm from '../../assets/background-login-sm.png';
import backgroundLoginLg from '../../assets/background-login-lg.png';

export const AuthContainer = styled('div')(({theme}) => ({
  backgroundColor: '#ecedf9',
  backgroundImage: `url(${backgroundLoginSm})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  minWidth: '100vw',
  minHeight: '100vh',
  paddingTop: theme.typography.pxToRem(80),
  [theme.breakpoints.up('md')]: {
    backgroundImage: `url(${backgroundLoginLg})`,
    paddingBottom: theme.typography.pxToRem(80),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
}));
